import type { IdTextPair, OptGroupData, OptionData } from 'select2';

import type { Icon } from '@disy/ui/icon';

export const PLACEHOLDER_ID = '';
export const PLACEHOLDER_TEXT = '$$_placeholder_value_$$';

/**
 An Object of data which will define the node element Option. One can store additional data which
 will be also returned by the selection getter.
 */
export interface SelectOption<DATA = unknown> {
  text: string;
  id: string;
  addSeparationLineBelow?: boolean;
  icon?: Icon;
  selected?: boolean;
  disabled?: boolean;
  data?: DATA;
}

export interface SelectOptionGroup<DATA = unknown> {
  text: string;
  children: SelectOption<DATA>[];
  addSeparationLineBelow?: boolean;
}

export type SelectItem<DATA = unknown> = SelectOption<DATA> | SelectOptionGroup<DATA>;

export type SelectQueryType = (params: SelectQueryParams, callback: (cbkArgs: SelectQueryCallbackArgs) => void) => void;

export interface SelectQueryParams {
  term: string;
  page: number;

  /** 'limit' and 'offset' are together an exclusive alternative to 'page' */
  limit: number;
  offset: number;
}

export interface SelectQueryCallbackArgs {
  pagination?: { more: boolean };
  results: unknown[];
  /**
   * If this is set to <code> true, a blue info box will be displayed when the user
   * runs out of selectable options. Makes sense only in the 'multiple' case.
   */
  showNoMoreSelectableOptionsMessage?: boolean;
}

export type SelectSorterType = (
  data: (OptGroupData | OptionData | IdTextPair)[],
) => (OptGroupData | OptionData | IdTextPair)[];

export function isPlaceholderOption(option: SelectOption) {
  return option.id === PLACEHOLDER_ID && option.text === PLACEHOLDER_TEXT;
}

export function isGroupItem<DATA>(item: SelectItem<DATA>): item is SelectOptionGroup<DATA> {
  return !!(item as SelectOptionGroup).children;
}
